import { INucDropdownItem } from '@relayter/rubber-duck';

type DropdownType = boolean | string | number;

export class DropdownOption implements INucDropdownItem<DropdownType> {
    constructor(
        private readonly title: string,
        private readonly value: DropdownType
    ) {}

    public getTitle(): string {
        return this.title;
    }

    public getValue(): DropdownType {
        return this.value;
    }
}
